import { find, get, findIndex, set, some, map } from 'lodash';
import {
  FETCH_CALLS,
  SELECT_CALL,
  SELECT_CALL_BY_PBX_ID,
  SET_CALLS,
  SET_CLIENT,
  SET_FILTERS,
  SET_NEW_CALL,
  SET_PAGE,
  SET_SELECTED_CALL,
  SET_CLIENT_ERROR,
  RESET_ERRORS,
  UPDATE_CALLS,
  UPDATE_NEW_CALL,
  UPDATE_CLIENT_IN_ALL_CALLS,
} from '../actions/calls';

import { VOX_LISTEN_START, VOX_LISTEN_STOP } from '../../consts/vox';

const initialState = {
  filters: {
    dates: null,
    page: 1,
    size: 50,
    type: null,
  },
  calls: [],
  callIds: {},
  errors: {},
  isFirstTimeLoading: false,
  isNextPageLoading: false,
  selectedCall: null,
  selectedCallId: null,
  selectedListeningPbxId: null,
  total: 0,
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case FETCH_CALLS: {
      return { ...state, isFirstTimeLoading: true, isNextPageLoading: true };
    }

    case SELECT_CALL: {
      const { id } = payload;
      const selectedCallId = id || null;
      const selectedCall = find(
        state.calls,
        ({ call }) => call.id === selectedCallId
      );

      if (selectedCall) selectedCall.contact.isLoaded = false;

      return {
        ...state,
        errors: {},
        selectedCall: { ...selectedCall },
        selectedCallId,
      };
    }

    case SELECT_CALL_BY_PBX_ID: {
      const { pbxId } = payload;
      const selectedCall = find(
        state.calls,
        ({ call }) => call.pbxId === pbxId
      );
      const selectedCallId = get(selectedCall, 'call.id') || null;

      if (selectedCall) selectedCall.contact.isLoaded = false;

      return {
        ...state,
        errors: {},
        selectedCall: { ...selectedCall },
        selectedCallId,
      };
    }

    case SET_CALLS: {
      const { calls, callIds, total } = payload;

      return {
        ...state,
        calls,
        callIds,
        isFirstTimeLoading: false,
        isNextPageLoading: false,
        total,
      };
    }

    case SET_PAGE: {
      const { page } = payload;
      return {
        ...state,
        filters: { ...state.filters, page },
        isNextPageLoading: true,
      };
    }

    case SET_CLIENT: {
      const { client: updatedContact } = payload;
      const {
        calls: allCalls,
        selectedCall: prevSelectedCall,
        selectedCallId,
      } = state;

      const calls = allCalls.map(callItem => {
        const contactId = get(callItem, 'contact.id');
        const contactPhone = get(callItem, 'contact.phone');

        if (
          updatedContact.phone === contactPhone ||
          updatedContact.id === contactId
        ) {
          const { orders } = prevSelectedCall;
          const { name, surname, phone } = updatedContact;
          const fullName =
            name || surname ? `${name || ''} ${surname || ''}` : phone;

          return {
            ...callItem,
            contact: {
              ...callItem.contact,
              ...{
                ...updatedContact,
                fullName,
              },
              isLoaded: true,
            },
            orders,
          };
        }

        return callItem;
      });
      const selectedCall = find(
        calls,
        ({ call }) => call.id === selectedCallId
      );

      return {
        ...state,
        errors: {},
        calls,
        selectedCall,
      };
    }

    case SET_FILTERS: {
      const { filters } = payload;
      return {
        ...state,
        filters: { ...state.filters, ...filters, page: 1 },
        calls: [],
        calldIds: {},
        isNextPageLoading: true,
        selectedCall: null,
        selectedCallId: null,
        total: 0,
      };
    }

    case SET_NEW_CALL: {
      const { call: activeCall } = payload;
      return { ...state, calls: [activeCall, ...state.calls] };
    }

    case SET_SELECTED_CALL: {
      const { call, contact, orders, relatives } = payload;
      let selectedCall =
        find(state.calls, ({ call }) => call.id === state.selectedCallId) ||
        call;
      const selectedCallIndex = findIndex(
        state.calls,
        ({ call }) => call.id === state.selectedCallId
      );

      selectedCall = {
        ...selectedCall,
        contact: {
          ...selectedCall.contact,
          ...contact,
          isLoaded: true,
        },
        orders,
        relatives,
      };
      state.calls.splice(selectedCallIndex, 1, selectedCall);
      return {
        ...state,
        calls: [...state.calls],
        selectedCall,
      };
    }

    case SET_CLIENT_ERROR: {
      const { errors } = payload;
      return { ...state, errors };
    }

    case RESET_ERRORS: {
      return { ...state, errors: {} };
    }

    case UPDATE_NEW_CALL: {
      const { call: activeCall } = payload;
      const index = findIndex(
        state.calls,
        ({ call }) => call.id === activeCall.call.id
      );
      if (index < 0) {
        return state;
      }
      state.calls.splice(index, 1, activeCall);
      return {
        ...state,
        calls: [...state.calls],
        selectedCall:
          state.selectedCallId === activeCall.call.id
            ? { ...state.selectedCall, ...activeCall }
            : state.selectedCall,
      };
    }

    case VOX_LISTEN_START: {
      const { pbxId } = payload;
      const { calls: allCalls } = state;
      const listeningCall = find(allCalls, ({ call }) => call.pbxId === pbxId);
      listeningCall.call.isListen = true;

      return {
        ...state,
        calls: [...allCalls],
        selectedListeningPbxId: pbxId,
      };
    }

    case VOX_LISTEN_STOP: {
      const { calls, selectedListeningPbxId } = state;
      const listeningCall = find(
        calls,
        ({ call }) => call.pbxId === selectedListeningPbxId
      );
      listeningCall.call.isListen = false;

      return {
        ...state,
        calls: [...calls],
        selectedListeningPbxId: null,
      };
    }

    case UPDATE_CALLS: {
      const { call: newCall } = payload;
      if (!newCall) {
        return state;
      }

      const newCallId = get(newCall, 'call.id');
      const newCallPbxId = get(newCall, 'call.pbxId');
      const newContactPhone = get(newCall, 'contact.phone');
      const newOperatorNumber = get(newCall, 'operator.number');
      const { calls, callIds } = state;
      const index = findIndex(calls, call => {
        const callId = get(call, 'call.id');
        const callPbxId = get(call, 'call.pbxId');
        // Попытка найти звонок по id или по pbxId (если он активный, то у него может не быть id).
        if (callId === newCallId || callPbxId === newCallPbxId) {
          return true;
        }

        // Если даже по pbxId найти звонок не удаётся (такое возможно для активного звонка, для
        // которого pbxId ещё не успел прийти от VoxImplant), то пробуем найти сэмулированный
        // звонок по данным контакта и оператора.
        const contactPhone = get(call, 'contact.phone');
        const operatorNumber = get(call, 'operator.number');
        if (
          call.isEmulated &&
          contactPhone === newContactPhone &&
          operatorNumber === newOperatorNumber
        ) {
          return true;
        }

        // Иначе это просто новый звонок и затем добавляем его в начало списка.
        return false;
      });

      let nextCalls = null;
      if (index === -1) {
        nextCalls = [newCall, ...calls];
        const latestCallInList = nextCalls.pop();
        callIds[newCallId] = true;
        delete callIds[latestCallInList.call.id];
      } else {
        calls.splice(index, 1, newCall);
        nextCalls = [...calls];
      }

      const { selectedCall, selectedCallId } = state;
      if (selectedCall) {
        const selectedContactPhone = get(selectedCall, 'contact.phone');
        const selectedOperatorNumber = get(selectedCall, 'operator.number');
        if (
          selectedCallId === newCallId ||
          selectedCallId === newCallPbxId ||
          (selectedCall.isEmulated &&
            selectedContactPhone === newContactPhone &&
            selectedOperatorNumber === newOperatorNumber)
        ) {
          const selectedContactId = get(selectedCall, 'contact.id');
          const newCallContactId = get(newCall, 'contact.id');
          set(
            newCall,
            'contact.isLoaded',
            selectedContactId === newCallContactId
          );

          return {
            ...state,
            calls: nextCalls,
            callIds,
            selectedCall: {
              ...selectedCall,
              ...newCall,
            },
            selectedCallId: newCallId,
          };
        }
      }

      return {
        ...state,
        calls: nextCalls,
        callIds,
        total: state.total + 1,
      };
    }

    case UPDATE_CLIENT_IN_ALL_CALLS: {
      const { client } = payload;
      if (!client) {
        return state;
      }

      const { calls } = state;
      const itHasCallsToChange = some(
        calls,
        ({ contact }) =>
          contact.id === client.id && contact.type === client.type
      );
      if (!itHasCallsToChange) {
        return state;
      }

      const callsWithUpdatedContact = map(calls, c => {
        const { contact } = c;
        if (contact.id === client.id && contact.type === client.type) {
          return {
            ...c,
            contact: { ...client },
          };
        }

        return c;
      });

      const { selectedCall } = state;
      let nextSelectedCall = null;
      if (selectedCall) {
        const { contact: selectedContact } = selectedCall;
        if (
          selectedContact.id === client.id &&
          selectedContact.type === client.type
        ) {
          nextSelectedCall = {
            ...selectedCall,
            contact: {
              ...client,
              isLoaded: true,
            },
          };
        } else {
          nextSelectedCall = selectedCall;
        }
      }

      return {
        ...state,
        calls: callsWithUpdatedContact,
        selectedCall: nextSelectedCall,
      };
    }

    default:
      return state;
  }
};
